import type React from 'react'
import { ALL_VIDEOS, SHEET_PILE_SECTIONS } from '@/constants'
import { useMainPageSearch } from '@/hooks/search/useMainPageSearch'
import {
  FindSheetPileSection,
  HeroSection,
  SearchByBendingMoment,
  SearchByName,
  SearchBySectionModulus,
} from '@/landing/components/main_page'
import { VideoSlider } from '@/landing/components/VideoSlider'

const MainPage: React.FC = () => {
  const {
    searchState,
    setters,
    refs,
    suggestions,
    modulusSuggestions,
    bendingSuggestions,
    handlers,
    loading,
    steelGradeOptions,
  } = useMainPageSearch()

  return (
    <div className="min-h-screen bg-white">
      <HeroSection />

      {/* Search Section */}
      <section className="py-8 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            {/* Search by Product Name */}
            <SearchByName
              productName={searchState.productName}
              showSuggestions={searchState.showSuggestions}
              selectedIndex={searchState.selectedIndex}
              suggestions={suggestions}
              nameSearchLoading={loading.nameSearchLoading}
              searchContainerRef={refs.searchContainerRef}
              handlers={handlers}
              onFocus={() => setters.setShowSuggestions(searchState.productName.length > 0)}
              onSelectedIndexChange={setters.setSelectedIndex}
              searchError={searchState.searchError}
            />

            {/* Find Sheet Pile Section */}
            <FindSheetPileSection items={SHEET_PILE_SECTIONS} />

            {/* Search by Section Modulus */}
            <SearchBySectionModulus
              sectionModulus={searchState.sectionModulus}
              sectionModulusUnit={searchState.sectionModulusUnit}
              showModulusSuggestions={searchState.showModulusSuggestions}
              modulusSuggestions={modulusSuggestions}
              modulusSearchLoading={loading.modulusSearchLoading}
              modulusSearchRef={refs.modulusSearchRef}
              onSectionModulusChange={setters.setSectionModulus}
              onUnitChange={setters.setSectionModulusUnit}
              onShowSuggestionsChange={setters.setShowModulusSuggestions}
              onSelectPanel={handlers.selectModulusPanel}
              onSearch={handlers.handleSectionModulusSearch}
              onFocus={() =>
                setters.setShowModulusSuggestions(searchState.sectionModulus.length > 0)
              }
            />

            {/* Search by Bending Moment Capacity */}
            <SearchByBendingMoment
              bendingMoment={searchState.bendingMoment}
              bendingMomentUnit={searchState.bendingMomentUnit}
              selectedSteelGrade={searchState.selectedSteelGrade}
              showBendingSuggestions={searchState.showBendingSuggestions}
              bendingSuggestions={bendingSuggestions}
              bendingSearchLoading={loading.bendingSearchLoading}
              steelGradeOptions={steelGradeOptions}
              steelGradesLoading={loading.steelGradesLoading}
              bendingSearchRef={refs.bendingSearchRef}
              onBendingMomentChange={setters.setBendingMoment}
              onUnitChange={setters.setBendingMomentUnit}
              onSteelGradeChange={setters.setSelectedSteelGrade}
              onShowSuggestionsChange={setters.setShowBendingSuggestions}
              onSelectPanel={handlers.selectBendingPanel}
              onSearch={handlers.handleBendingMomentSearch}
              onFocus={() =>
                setters.setShowBendingSuggestions(searchState.bendingMoment.length > 0)
              }
            />
          </div>
        </div>
      </section>

      {/* Videos Section */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <VideoSlider videos={ALL_VIDEOS} title="Watch Our Videos" />
        </div>
      </section>
    </div>
  )
}

export default MainPage
